import React from "react";
import Hero from "./hero";
import Navbar from "../Components/navbar";
import Secone from "./secone";
import Sectwo from "./sectwo";
import Secthree from "./secthree";
import Secfour from "./secfour";
import Footer from "../Components/Footer";

const Homelink = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Secone />
      <Sectwo />
      <Secthree />
      <Secfour />
      <Footer />
    </>
  );
};

export default Homelink;

